import Vue from 'vue'

import dateTime from '../helpers/dateTime'
import string from '../helpers/string'

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('readableDate', function (value) {
  return dateTime.readableDate(value)
})

Vue.filter('readableTime', function (value) {
  return dateTime.readableTime(value)
})

Vue.filter('readableDateTime', function (value) {
  return dateTime.readableDateTime(value)
})

Vue.filter('getFirstInitial', function (value) {
  return string.getFirstInitial(value)
})

Vue.filter('toUpperCase', function (value) {
  return string.toUpperCase(value)
})

Vue.filter('toUpperCaseFirst', function (value) {
  return string.toUpperCaseFirst(value)
})

Vue.filter('jsonEncode', function (value) {
  return string.jsonEncode(value)
})
